// extracted by mini-css-extract-plugin
export default {"spinner":"styles_spinner__qzBJN","btn":"styles_btn__33cye"};